import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Image, Table } from "react-bootstrap";
import {
  MdOutlineEdit,
  MdDeleteOutline,
  MdAddCircleOutline,
  MdOutlineCategory,
} from "react-icons/md";
import { RiFilterOffLine } from "react-icons/ri";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { apiGetPersonnes, apiExportPersonnes } from "../../api/ApiPersonnes";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ModalDelete from "../../components/admin/personne/ModalDelete";
import ModalChoixOrgunits from "../../components/admin/personne/ModalChoixOrgunits";
import genericAvatar from "../../assets/images/generic-avatar.jpeg";
import { GrDocumentCsv } from "react-icons/gr";
const PageAdminPersonnes = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [personnes, setPersonnes] = useState([]);
  const [personnesOri, setPersonnesOri] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [idPersonne, setIdPersonne] = useState("");
  const [showOrgunits, setShowOrgunits] = useState(false);
  const navigate = useNavigate();

  const recupPersonnes = async () => {
    const res = await apiGetPersonnes(ReduxInstance._id);
    setPersonnes(res.data);
    setPersonnesOri(res.data);
  };

  useEffect(() => {
    recupPersonnes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleShowDelete = (id) => {
    setIdPersonne(id);
    setShowDelete(true);
  };

  const handleCloseDelete = () => {
    setIdPersonne(null);
    setShowDelete(false);
  };

  const handleShowOrgunits = (id) => {
    setIdPersonne(id);
    setShowOrgunits(true);
  };

  const handleCloseOrgunits = () => {
    setShowOrgunits(false);
  };

  const exportCollaborateurs = async () => {
    await apiExportPersonnes(ReduxInstance._id, "include=marque");
  };

  const filtreAlphabet = (lettre) => {
    if (lettre) {
      const personnesAlphabetFilter = personnesOri.filter(
        (item) => item.prenom.charAt(0).toLowerCase() === lettre.toLowerCase()
      );
      setPersonnes(personnesAlphabetFilter);
    } else {
      setPersonnes(personnesOri);
    }
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminCollaborateurs.titre")} />
        <span role="button" onClick={() => navigate("/admin/easygouv/personnes/create")}>
          <MdAddCircleOutline size="1.5em" /> {t("admin.PageAdminCollaborateurs.ajouter")}
        </span>
        <GrDocumentCsv
          className="float-end"
          size="1.5em"
          role="button"
          onClick={() => {
            exportCollaborateurs();
          }}
        />

        <Table striped bordered hover className="stickyTable mt-2">
          <thead>
            <tr className="text-center">
              <td colSpan="5">
                <div className="contentAlphabet d-flex justify-content-center align-items-center flex-wrap">
                  {personnesOri.length !== personnes.length && (
                    <span role="button" className="me-3" onClick={() => filtreAlphabet("")}>
                      <RiFilterOffLine size="1.5em" role="button" />
                    </span>
                  )}
                  <span role="button" onClick={() => filtreAlphabet("A")}>
                    A
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("B")}>
                    B
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("C")}>
                    C
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("D")}>
                    D
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("E")}>
                    E
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("F")}>
                    F
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("G")}>
                    G
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("H")}>
                    H
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("I")}>
                    I
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("J")}>
                    J
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("K")}>
                    K
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("L")}>
                    L
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("M")}>
                    M
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("N")}>
                    N
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("O")}>
                    O
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("P")}>
                    P
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("Q")}>
                    Q
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("R")}>
                    R
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("S")}>
                    S
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("T")}>
                    T
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("U")}>
                    U
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("V")}>
                    V
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("W")}>
                    W
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("X")}>
                    X
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("Y")}>
                    Y
                  </span>
                  <span role="button" onClick={() => filtreAlphabet("Z")}>
                    Z
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th>{t("admin.PageAdminCollaborateurs.titreColonne1")}</th>
              <th>{t("admin.PageAdminCollaborateurs.titreColonne2")}</th>
              <th className="text-center">{t("admin.PageAdminCollaborateurs.titreColonne3")}</th>
              <th className="text-center">{t("admin.PageAdminCollaborateurs.titreColonne4")}</th>
              <th className="text-center">{t("admin.PageAdminCollaborateurs.titreColonne5")}</th>
            </tr>
          </thead>
          <tbody>
            {personnes.map((personne) => (
              <tr key={personne._id}>
                <td>
                  <Image
                    src={
                      personne.profilePic
                        ? process.env.REACT_APP_URL_EXPRESS +
                          "images/avatar/small/" +
                          personne.profilePic
                        : genericAvatar
                    }
                    rounded
                    style={{ objectFit: "cover" }}
                    width={50}
                  />
                </td>
                <td className="align-middle">
                  {personne.prenom} {personne.nom}
                </td>
                <td className="text-center align-middle">
                  <MdOutlineCategory
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowOrgunits(personne._id)}
                  />
                </td>
                <td className="text-center align-middle">
                  <MdOutlineEdit
                    size="1.5em"
                    role="button"
                    onClick={() =>
                      navigate("/admin/easygouv/personnes/" + personne._id + "/update")
                    }
                  />
                </td>
                <td className="text-center align-middle">
                  <MdDeleteOutline
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowDelete(personne._id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ModalDelete
          show={showDelete}
          id={idPersonne}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupPersonnes}
        />
        <ModalChoixOrgunits
          show={showOrgunits}
          idPersonne={idPersonne}
          handleClose={handleCloseOrgunits}
          ReduxInstanceId={ReduxInstance._id}
        />
      </Container>
    </>
  );
};

export default PageAdminPersonnes;
